import { defaults, now } from 'lodash';
import { computed, ref } from 'vue';

/**
 * Holds a loading state, with configurable minimum load time to avoid UI jitter (default: 500ms)
 */
export const useLoading = (options: { startLoading?: boolean; minimumTime?: number } = {}) => {
  const defaultedOptions = defaults(options, {
    startLoading: true,
    minimumTime: 500,
  });

  const loading = ref(defaultedOptions.startLoading);

  let loadingTime: number = 0;
  let timer: ReturnType<typeof setTimeout> | undefined = undefined;

  if (defaultedOptions.startLoading) {
    loadingTime = now();
  }

  return computed<boolean>({
    get: () => loading.value,
    set: (value) => {
      if (value) {
        loading.value = true;
        loadingTime = now();
      } else {
        const delta = loadingTime + defaultedOptions.minimumTime - now();

        if (delta < 0) {
          loading.value = false;
        } else if (timer === undefined) {
          timer = setTimeout(() => {
            if (loading.value) {
              loading.value = false;
            }

            timer = undefined;
          }, delta);
        }
      }
    },
  });
};
